import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
    page: {
        maxWidth: '100%',
        backgroundColor: 'rgb(83, 83, 83)',
        borderRadius: 12,
        shadowColor: "#0000006b",
        shadowOffset: {
            width: 1,
            height: 0,
        },
        shadowOpacity: 0.35,
        shadowRadius: 20.32,
        flexDirection: 'row',
        flexGrow: 0.025,
        paddingRight: 15
    },
    menu: {
        paddingVertical: 6,
        justifyContent: 'space-between',
        paddingHorizontal: 24,
        flexShrink: 1,
    },
    selected: {
        backgroundColor: '#FFC646',
        borderRadius: 12,
        alignItems: 'center',
        alignSelf: 'center',
        justifyContent: 'center',
        alignContent: 'center',
        height: 44
    },
    unselected: {
        backgroundColor: 'rgb(83, 83, 83)',
        alignItems: 'center',
        alignSelf: 'center',
        justifyContent: 'center',
        alignContent: 'center',
        height: 44
    },
    navigationTextColorSelected: {
        color: 'rgb(83, 83, 83)',
    },
    navigationTextColorUnselected: {
        color: "#FCFCFC",
    },
    navigationText: {
        fontSize: 18,
        fontFamily: 'Montserrat',
        fontWeight: "500",
        textAlign: 'center',
    }
});